import { ListActionsAndIssuesGraphRequest_Target } from '@wavingroup/aqora-v2-api/wavin/aqora/v2/aqora_service_pb';
import { queryOptions } from '@tanstack/react-query';
import { SystemBehaviourModel } from '~/pages/Metrics/models/SystemBehaviourModel';
import { listActionsAndIssuesGraph } from '~/services/api/fetchers/metrics.api';

export const systemBehaviourQuery = ({
  targets,
}: {
  targets: ListActionsAndIssuesGraphRequest_Target[];
}) =>
  queryOptions({
    queryKey: ['systemBehaviour', targets],
    queryFn: async () => {
      const response = await listActionsAndIssuesGraph(targets);

      return new SystemBehaviourModel(response);
    },
    staleTime: 60 * 5_000,
  });
